import styled from '@emotion/styled';
import {
  OL_COLOUR_BLACK_90,
  OL_COLOUR_CTA_PINK,
} from '../../../../components/Style/colours';

export const StyledForm = styled.form`
  margin-bottom: 2px;
`;

export const StyledLabel = styled.label`
  color: white;
  display: block;
  margin: 0;
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.8;
`;

export const StyledInput = styled.input`
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 2.4375rem;
  margin-top: 0;
  margin-bottom: 1rem;
  margin-right: 0;
  margin-left: 0;
  padding: 0.5rem;
  border: 1px solid #cacaca;
  border-radius: 5px;
  background-color: #fefefe;
  font-family: inherit;
  font-weight: normal;
  line-height: 1.5;
  font-size: 14px;
  color: ${OL_COLOUR_BLACK_90};
  transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
  box-shadow: none;
`;

export const StyledButton = styled.button`
  background-color: ${OL_COLOUR_CTA_PINK};
  color: white;
  text-shadow: none;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  min-width: 150px;
  padding: 12px 2em;
  margin-top: 12px;
  border-radius: 5px;
  border: none;
  box-shadow: none;
`;

export const StyledErrorBlock = styled.div`
  background-color: white;
  border-radius: 10px;
  margin-bottom: 1rem;
`;
